import React from 'react';
import DisclaimerLib from './DisclaimerLib';

function CareLabelsExpandView({ subBrandAccess, index, data, libName }) {
  const totalCareLibs = {
    totalDiscLib: data.careLableLibaries[0].disclaimerLibraries.length,
    totalInstLib: data.careLableLibaries[0].instructionLibraries.length,
    totalSymbolLib: data.careLableLibaries[0].symbolLibraries.length,
  };
  return (
    <DisclaimerLib
      subBrandAccess={subBrandAccess}
      index={index}
      data={data}
      totalCareLibs={totalCareLibs}
      disclaimerLibraries={data.careLableLibaries[0].disclaimerLibraries}
    />
  );
}

export default CareLabelsExpandView;
